import { gql } from "@apollo/client";

const REJECT_DESTINATION = gql`
  mutation RejectDestination($id: String!, $rejectionComment: String!) {
    rejectDestination(id: $id, rejectionComment: $rejectionComment)
  }
`;

export default REJECT_DESTINATION;
